<!-- <div *ngIf="!props.isHidden">
    <label class="form-label fg-label my-3" for="{{ props.field_Name }}">{{ props.label }} <span class="text-danger"
            *ngIf="props.required">*</span></label>

    <textarea class="col-12 form-control" rows="3" placeholder="{{ props.label }}" #fieldValue
        formControlName="{{ props.field_Name }}" maxlength="{{ props.maxlength }}" minlength="{{ props.minlength }}"
        [ngClass]="props.readOnly === true ? 'disabled-input' : ''"
        readonly="{{ props.readOnly === true ? 'readonly' : '' }}"></textarea>
    <small>{{ fieldValue?.value?.length || '0' }} / {{ props.maxlength }} </small><br />
    <sm-error [control]="formcontrol"></sm-error>
</div> -->

<div *ngIf="!props.isHidden">
    <label class="form-label fg-label" for="{{ props.field_Name }}">
        {{ props.label }} 
        <span *ngIf="props.required">*</span>
    </label>

    <textarea class="col-12 form-control"
       
        [rows]="props.field_Name === 'question' ? '3' : '6'"
        placeholder="{{ props.placeholder }}"
        #fieldValue
        formControlName="{{ props.field_Name }}"
        maxlength="{{ props.maxlength }}"
        minlength="{{ props.minlength }}"
        [ngClass]="props.readOnly === true ? 'disabled-input' : ''"
        [readonly]="props.readOnly === true">
    </textarea>
    <div class="text-end">
        <small>{{ fieldValue.value?.length || 0 }} / {{ props.maxlength }}</small><br />
    </div>
    
    <!-- <sm-error [control]="formcontrol"></sm-error> -->
    <sm-error [control]="formcontrol" [label]="'Field'"></sm-error>

</div>
